import {
  ProductRealmSchema
} from "../chunk-HJPR3SS7.js";

// brand/brand.schema.ts
import { z } from "zod";
var DbBrandSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  short_code: z.string().min(2).max(6),
  logo: z.string().nullable(),
  description: z.string().nullable(),
  // Use coerce to handle string values from database (TEXT column)
  b2bwave_brand_id: z.coerce.number().nullable(),
  source: z.string().nullable(),
  /** @deprecated Use org-level skip_fulfillment_offers instead */
  is_flote_owned: z.boolean().optional().default(false),
  delivery_team_id: z.string().uuid().nullable().optional(),
  realm: ProductRealmSchema.default("cannabis"),
  created_at: z.union([z.string(), z.date()]),
  updated_at: z.union([z.string(), z.date()])
});
var CreateDbBrandSchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string(),
  short_code: z.string().min(2).max(6),
  logo: z.string().nullable(),
  description: z.string().nullable(),
  // Use coerce to handle string values from database (TEXT column)
  b2bwave_brand_id: z.coerce.number().nullable(),
  source: z.string().nullable(),
  /** @deprecated Use org-level skip_fulfillment_offers instead */
  is_flote_owned: z.boolean().optional(),
  delivery_team_id: z.string().uuid().nullable().optional(),
  realm: ProductRealmSchema.default("cannabis"),
  created_at: z.string().optional(),
  updated_at: z.string().optional()
});
var UpdateDbBrandSchema = CreateDbBrandSchema.partial();
var BrandSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  shortCode: z.string().min(2).max(6),
  logoUrl: z.string().nullable(),
  description: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
  b2bwaveBrandId: z.number().nullable(),
  source: z.string(),
  /** @deprecated Use org-level skip_fulfillment_offers instead */
  isFloteOwned: z.boolean().optional().default(false),
  deliveryTeamId: z.string().uuid().nullable().optional(),
  realm: ProductRealmSchema.default("cannabis")
});
var BrandDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  shortCode: z.string().min(2).max(6),
  logoUrl: z.string().nullable(),
  description: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  brandColor: z.string().nullable().optional(),
  b2bwaveBrandId: z.number().nullable(),
  source: z.string(),
  /** @deprecated Use org-level skip_fulfillment_offers instead */
  isFloteOwned: z.boolean().optional(),
  deliveryTeamId: z.string().uuid().nullable().optional(),
  realm: ProductRealmSchema.default("cannabis")
});
var CreateBrandDtoSchema = BrandDtoSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  brandColor: true
});
var UpdateBrandDtoSchema = CreateBrandDtoSchema.partial();
var B2BWaveBrandSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  sort: z.number().nullable(),
  is_active: z.boolean(),
  image_url: z.string()
});
var B2BWaveBrandDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  sort: z.number().nullable(),
  isActive: z.boolean(),
  imageUrl: z.string()
});
export {
  B2BWaveBrandDtoSchema,
  B2BWaveBrandSchema,
  BrandDtoSchema,
  BrandSchema,
  CreateBrandDtoSchema,
  CreateDbBrandSchema,
  DbBrandSchema,
  UpdateBrandDtoSchema,
  UpdateDbBrandSchema
};
